var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#0A64C8",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5146_17102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5 53.3333V61.6667C70.5 66.2617 66.7617 70 62.1667 70H38.8333C34.2383 70 30.5 66.2617 30.5 61.6667V43.3333C30.5 38.7383 34.2383 35 38.8333 35H45.5C46.42 35 47.1667 35.745 47.1667 36.6667C47.1667 37.5883 46.42 38.3333 45.5 38.3333H38.8333C36.9683 38.3333 35.3567 39.3717 34.4983 40.89L47.1433 53.535C49.0333 55.4233 52.325 55.4233 54.215 53.535L54.7633 52.9867C55.415 52.3383 56.4683 52.3367 57.12 52.9867C57.77 53.64 57.77 54.6933 57.12 55.345L56.5717 55.8917C54.9983 57.4633 52.9067 58.3317 50.68 58.3317C48.4533 58.3317 46.3617 57.4633 44.7883 55.89L33.8367 44.9383V61.665C33.8367 64.4217 36.08 66.665 38.8367 66.665H62.17C64.9267 66.665 67.17 64.4217 67.17 61.665V53.3317C67.17 52.41 67.9167 51.665 68.8367 51.665C69.7567 51.665 70.5033 52.41 70.5033 53.3317L70.5 53.3333ZM50.5 40C50.5 34.485 54.985 30 60.5 30C66.015 30 70.5 34.485 70.5 40C70.5 45.515 66.015 50 60.5 50C54.985 50 50.5 45.515 50.5 40ZM53.8333 40C53.8333 43.6767 56.8233 46.6667 60.5 46.6667C64.1767 46.6667 67.1667 43.6767 67.1667 40C67.1667 36.3233 64.1767 33.3333 60.5 33.3333C56.8233 33.3333 53.8333 36.3233 53.8333 40ZM60.9883 42.845C61.3133 43.17 61.74 43.3333 62.1667 43.3333C62.5933 43.3333 63.02 43.17 63.345 42.845C63.9967 42.1933 63.9967 41.14 63.345 40.4883L62.1667 39.31V36.6667C62.1667 35.745 61.42 35 60.5 35C59.58 35 58.8333 35.745 58.8333 36.6667V40C58.8333 40.4433 59.0083 40.8667 59.3217 41.1783L60.9883 42.845Z",
    fill: "#0A64C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5146_17102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(30.5 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.d09910c1049975403a7f996400daaebc.svg";
export { ForwardRef as ReactComponent };